/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailManufactureDate_item = {|
  +classification: ?{|
    +creationDate: ?string;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailManufactureDate_item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemClassification",
      "name": "classification",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "creationDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
